<template>
	<span v-tooltip="options" ref="tooltip" class="persistent-tooltip"></span>
</template>
<script>
	export default {
		name: 'persistent-tooltip',
		props: ['content', 'placement', 'tipclassname', 'buttonclassname'],
		data () {
			return {
				options: {
					placement: this.placement || 'right', // side (+ '-' + 'start'/'end')
					content: this.content || `<p>&nbsp;</p>`,
					trigger: 'click',
					template: `
						<div class="${this.tipclassname || 'tooltip'}" role="tooltip">
							<div class="tooltip-arrow"></div>
							<span class="tooltip-close btn btnSm ${this.buttonclassname || 'btnRed'}" id="persistent-tooltip__${this._uid}">OK, got it</span>
							<div class="tooltip-inner"></div>
						</div>
					`,
					boundariesElement: 'body'
				}
			}
		},
		methods: {
			handleCloseClick (e) {
				if (e.target && e.target.matches(`#persistent-tooltip__${this._uid}`)) {
					this.$refs.tooltip.click()
					this.$emit('remove')
				}
			}
		},
		mounted () {
			this.$refs.tooltip.click()
			document.body.addEventListener('click', this.handleCloseClick)
		},
		destroyed () {
			document.body.removeEventListener('click', this.handleCloseClick)
		}
	}
</script>
<style lang="scss">
	.persistent-tooltip {
		display:inline-block;
		height: 0;
		width: 0;
		font-size:0;
		overflow:hidden;
	}
</style>
